const loginUrl = process.env.REACT_APP_LOGIN_URL || 'https://portal.wmca.org.uk/api/login';
const registerUrl = process.env.REACT_APP_REGISTER_URL || 'https://portal.wmca.org.uk/api/login/register';
const forgotPasswordUrl = process.env.REACT_APP_FORGOT_PASSWORD_URL || 'https://portal.wmca.org.uk/api/login/forgot';
const resetPasswordUrl = process.env.REACT_APP_RESET_PASSWORD_URL || 'https://portal.wmca.org.uk/api/login/reset';
const permissionsUrl = process.env.REACT_APP_PERMISSIONS_URL || 'https://portal.wmca.org.uk/api/login/permissions';


export { loginUrl, registerUrl, forgotPasswordUrl, resetPasswordUrl, permissionsUrl }
